export default __webpack_public_path__ + "static/media/js.c863dc1f.png";